module.exports = __webpack_public_path__ + "static/media/event-services-img29.5aa61c41.jpg";